module.exports = __webpack_public_path__ + "img/shield-icon.7a97cce0.png";